import styled, { css } from 'styled-components';

const MAX_BUTTON_WIDTH = 50;
const MAX_BUTTON_HEIGHT = 30;
const MAX_BUTTON_RIGHT_OFFSET = 10;
const TRACK_PADDING = 20;

const StyledContainer = styled.div<{ $height: number; $disabled?: boolean }>`
	position: relative;
	display: flex;
	align-items: stretch;
	width: 100%;
	height: ${({ $height }) => $height}px;
	background-color: rgba(255, 255, 255, 0.05);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	overflow: hidden;

	${({ $disabled }) =>
		$disabled &&
		css`
			opacity: 0.5;
			pointer-events: none;
		`}
`;

const StyledTrackWrapper = styled.div`
	position: relative;
	flex: 1;
	min-width: 0;
	display: flex;
	align-items: center;
	padding: 0 ${TRACK_PADDING}px;
`;

const StyledFill = styled.div`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	background-color: #2d70da;
	opacity: 0.25;
	pointer-events: none;
`;

const StyledProgressLine = styled.div`
	position: absolute;
	left: ${TRACK_PADDING}px;
	right: ${TRACK_PADDING}px;
	top: 50%;
	height: 1px;
	transform: translateY(-50%);
	background-color: rgba(255, 255, 255, 0.1);
	pointer-events: none;
`;

const THUMB_SIZE = 12;

const StyledRange = styled.input.attrs({ type: 'range' })<{
	$height: number;
}>`
	appearance: none;
	width: calc(100% + 12px);
	height: 100%;
	margin: 0 -6px;
	background: transparent;
	cursor: pointer;
	position: relative;
	z-index: 1;

	&:focus {
		outline: 0;
	}

	&::-webkit-slider-runnable-track {
		height: 100%;
		background: transparent;
	}

	&::-webkit-slider-thumb {
		appearance: none;
		width: ${THUMB_SIZE}px;
		height: ${THUMB_SIZE}px;
		margin-top: ${({ $height }) => ($height - THUMB_SIZE) / 2 - 1}px;
		border-radius: 50%;
		background-color: #ffffff;
		border: 0;
		cursor: pointer;
	}

	&:disabled {
		cursor: default;
	}
`;

const StyledMaxButton = styled.button.attrs({ tabIndex: -1 })`
	flex-shrink: 0;
	align-self: center;
	width: ${MAX_BUTTON_WIDTH}px;
	height: ${MAX_BUTTON_HEIGHT}px;
	margin-right: ${MAX_BUTTON_RIGHT_OFFSET}px;
	border: 0;
	border-radius: 5px;
	background-color: #2d70da;
	color: #ffffff;
	font-family: 'GT Walsheim Pro';
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
	line-height: 16px;
	cursor: pointer;
	user-select: none;
	transition:
		background-color 0.3s ease,
		color 0.3s ease;

	&:hover {
		background-color: #ffffff;
		color: #000000;
	}

	&:disabled {
		cursor: default;
		pointer-events: none;
	}
`;

export {
	StyledContainer,
	StyledFill,
	StyledMaxButton,
	StyledProgressLine,
	StyledRange,
	StyledTrackWrapper,
};
